import React from 'react';
import PropTypes from 'prop-types';

const DownloadIcon = ({ className }) => {
  return (

    <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    className={`fill-current ${className}`}
    fill="currentColor" // Ensures the color can be changed dynamically
    >
    <path fillRule="evenodd" clipRule="evenodd" d="M8.87837 11.2377C9.12245 10.9937 9.51818 10.9937 9.76225 11.2377L11.8803 13.3558L13.9984 11.2377C14.2424 10.9937 14.6382 10.9937 14.8823 11.2377C15.1263 11.4818 15.1263 11.8776 14.8823 12.1216L12.3223 14.6816C12.0782 14.9257 11.6824 14.9257 11.4384 14.6816L8.87837 12.1216C8.63429 11.8776 8.63429 11.4818 8.87837 11.2377Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.8809 3.375C12.226 3.375 12.5059 3.65482 12.5059 4V14.17C12.5059 14.5152 12.226 14.795 11.8809 14.795C11.5357 14.795 11.2559 14.5152 11.2559 14.17V4C11.2559 3.65482 11.5357 3.375 11.8809 3.375Z" fill="currentColor"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M4 11.5547C4.34518 11.5547 4.625 11.8345 4.625 12.1797C4.625 14.2485 5.32594 16.0885 6.57814 17.4067C7.82565 18.72 9.65703 19.5547 12 19.5547C14.343 19.5547 16.1744 18.72 17.4219 17.4067C18.6741 16.0885 19.375 14.2485 19.375 12.1797C19.375 11.8345 19.6548 11.5547 20 11.5547C20.3452 11.5547 20.625 11.8345 20.625 12.1797C20.625 14.5308 19.8259 16.6909 18.3281 18.2676C16.8256 19.8494 14.657 20.8047 12 20.8047C9.34297 20.8047 7.17435 19.8494 5.67186 18.2676C4.17406 16.6909 3.375 14.5308 3.375 12.1797C3.375 11.8345 3.65482 11.5547 4 11.5547Z" fill="currentColor"/>
    </svg>
    
  );
};

DownloadIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

DownloadIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default DownloadIcon;